function getDeliveryCountryMap() {
  const {start} = window;
  return start?.addresses?.deliveryCountries || {};
}

function deliveryCountries(countryMap) {
  return Object.keys(countryMap)
    .map(key => ({code: key, name: countryMap[key]}))
    .sort((c1, c2) => c1.name.toLowerCase().localeCompare(c2.name.toLowerCase()));
}

export default {
  getByCountryCode(countryCode) {
    return getDeliveryCountryMap()[countryCode] || countryCode;
  },
  getMap() {
    return getDeliveryCountryMap();
  },
  getList() {
    return deliveryCountries(getDeliveryCountryMap());
  },
};
